import type { EntityRegisterResponseRow } from '@risksmart-app/trpc/types';
import type { GetEntitiesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetEntitiesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetEntitiesArgs = Record<string, never>;

export const useGetEntities = createQueryHook<
  UseGetEntitiesArgs,
  EntityRegisterResponseRow[],
  GetEntitiesQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.entity.register.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ entity: data ?? [] }),
  graphqlDocument: GetEntitiesDocument,
});
